import { Icon, Text } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

export namespace RateManagementPillButtonTypes {
  export interface Props {
    isMobile: boolean;
  }
}
export const FeedbackConfirmed: React.FC<RateManagementPillButtonTypes.Props> = ({ isMobile }) => {
  return (
    <>
      <Box
        width={59}
        height={59}
        padding={Spacing['stack.quarck']}
        borderRadius={'full'}
        backgroundColor={Color['feedback.success.default']}>
        <Icon
          testId="status-icon"
          size={'xl'}
          color={Color['feedback.success.lightest']}
          name={'Check'}
          backgroundColor={Color['feedback.success.default']}
        />
      </Box>
      <Text
        lineHeight="medium"
        textAlign={'center'}
        paddingTop={Spacing['stack.sm']}
        fontSize={Typography['fontsize.xl']}
        fontWeight={Typography['fontweight.light']}>
        Obrigado pela confirmação!
      </Text>
      <Text
        lineHeight="medium"
        textAlign={'center'}
        maxWidth={isMobile ? 320 : '40%'}
        paddingTop={Spacing['stack.nano']}
        fontSize={Typography['fontsize.md']}
        fontWeight={Typography['fontweight.light']}>
        Você está confirmado(a)! Agora, aguarde. Em breve, seu assessor enviará oportunidades de
        investimento diretamente para você.
      </Text>
    </>
  );
};
